// extracted by mini-css-extract-plugin
export default {"sales-campaign-list-space":"sales-campaign-list-space_vWpJF","left-col":"left-col_bMAfc","right-col":"right-col_NOjXZ","filter-bar":"filter-bar_U2Go5"};